// extracted by mini-css-extract-plugin
export var externalLink = "_al-0";
export var internalLinkLabel = "_al-1";